module.exports = __webpack_public_path__ + "img/telegram.c95f9a7c.svg";